import { Reveal } from "@/motion";
import { Section } from "@/components/Section";
import { Logo } from "@/components/marks/Logo";

export function SymbolStory() {
  return (
    <Section id="symbol" labelledBy="symbol-title" tone="surface">
      <div className="split split--reverse">
        <Reveal className="symbol__mark" distance={24}>
          <Logo className="symbol__logo" alt="" />
        </Reveal>

        <Reveal as="div" className="symbol__copy" distance={24} delay={0.08}>
          <p className="eyebrow">The symbol</p>
          <h2 id="symbol-title" className="section__title">
            Two paths.
            <br />
            One direction.
          </h2>
          <p className="measure">
            The mark is a single geometric P with the motion stroke broken away
            from the bowl. The gap between them is the point: two separate lines
            travelling at their own speed, reading as one shape and one direction.
          </p>
        </Reveal>
      </div>
    </Section>
  );
}
